import { NavLink as RouterNavLink } from 'react-router-dom';
import clsx from 'clsx';

import styles from './layout.module.scss';

interface NavLinkProps {
  to: string;
  end?: boolean;
  children: React.ReactNode;
}

export const NavLink = ({ to, end, children }: NavLinkProps) => {
  return (
    <RouterNavLink to={to} end={end} className={({ isActive }) => clsx(styles.navLink, isActive && styles.navLinkActive)}>
      {children}
    </RouterNavLink>
  );
};
